var styleDataHash = "79565a43";
const injectCss = () => {
  var css = `.glob_fontElementMap,.w4YyZ{font-family:var(--ricos-font-family,unset)}.ixuc5{align-items:center;color:var(--ricos-settings-text-color,#000);display:flex;font-size:14px;height:40px;width:100%}[dir] .ixuc5{background-color:#fff}[dir=ltr] .ixuc5,[dir=rtl] .ixuc5{padding-left:20px;padding-right:20px}.ixuc5>*{flex:1}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_toggle_default = {
  "fontElementMap": "w4YyZ",
  "container": "ixuc5"
};
export {
  list_item_toggle_default as default,
  injectCss
};
//# sourceMappingURL=list-item-toggle-scss.js.map
